import dynamic from 'next/dynamic';
import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import { useTimeout } from '@/hooks/utils';

import AnimatedScreenWrapper from '../../Components/AnimatedScreenWrapper';
import Heading from '../../Components/Heading';
import { PreSignupFlowContext } from '../../PreSignupProvider';
import { breatheScreenMessages as messages } from './messages';
import { GradientBackground } from './styles';

// This avoids the `document is not defined` error during SSR
// See: https://github.com/airbnb/lottie-web/issues/3047
const BreatheBubble = dynamic(() => import('@/components/ui/BreatheBubble'), { ssr: false });

const BreatheScreen = () => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { transitionType } = ActiveScreen;

	const onContinue = async () => {
		logEvent({
			eventName: 'FTUE : Transition : Proceeded',
			eventProps: {
				transition_type: transitionType as string,
			},
		});
		nextScreen();
	};

	useTimeout(onContinue, 10000);

	return (
		<>
			<GradientBackground />
			<AnimatedScreenWrapper>
				<Heading centerAboveMobile color="white">
					{formatMessage(messages.title)}
				</Heading>
				<BreatheBubble />
			</AnimatedScreenWrapper>
		</>
	);
};

export default BreatheScreen;
